import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/select-dealer/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1210}
              height={941}
            />
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F15D20" }}>Solution</span>
            </h2>
            <p>
              We designed Select Dealer Service to be an intuitive digital
              platform that helps visitors to have a smooth experience
              navigating through the website and find all the information they
              might need.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
